import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import http from "../../../commonFunctions/htttpClientNew";
import WSButton from "../../../Components/Button/WSButton";

import WSDataGridForDashboard, {
  IColumns
} from "../../../Components/DataGrid/WSDataGridForDashboard";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import config from "../../../Config/config.json";
import { resetDataComponent } from "../../../StateManagement/actions";
export const ReconciliationList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "chequeIssued",
        operator: "eq",
        value: "true"
      },
      {
        field: "reconciling",
        operator: "eq",
        value: "false"
      }
    ],
    sort: [{ field: "DueDate", direction: "desc" }]
  };

  const columns: IColumns[] = [
    {
      header: "Supplier Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      type: "default"
    },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },
    {
      header: "Due Date",
      fieldName: "dueDate",
      type: "date"
    },

    {
      header: "Category",
      fieldName: "category",
      type: "default"
    }
  ];

  const transFormData = (data: any[]) => {
    if (!data) return [];
    data.forEach((item) => {
      item.name = item?.supplier?.name;
    });
    return data;
  };

  const handleSelectionChange = (response: any[]) => {
    if (Array.isArray(response) && response.length > 0) {
      const ids = response.map((item) => item.id);
      console.log("Selected IDs:", ids);
      setSelectedIds(ids);
    } else {
      setSelectedIds([]); // Ensures state resets when no selection
    }
  };
  const handleSaveClick = async () => {
    try {
      if (selectedIds.length > 0) {
        setLoading(true);
        const request = {
          id: selectedIds
        };
        const response: any = await http.post(
          config.apiDashboardBaseUrl + "Bill/bulk-reconcile-cheques",
          request
        );
        if (response && response.message) {
          setLoading(false);
          dispatch(resetDataComponent("reconciliationListGrid"));
          showMessage(response.message, "success");
        }
      }
    } catch (e) {
      console.error("Error in saving:", e);
    } finally {
      setLoading(false);
    }
  };
  const handleCancelClick = () => {
    setSelectedIds([]);
    navigate("/home");
  };

  const filterRows: IRows[] = [
    {
      label: "Due Name",
      fieldName: "DueDate",
      type: "betweenDate",
      operator: "between"
    }
  ];

  //   const filterRows: IRows[] = [
  //     {
  //       label: "Invoice Date From",
  //       fieldName: "invoiceDate",
  //       type: "date",
  //       operator: "greaterThanOrEqual"
  //     },
  //     {
  //       label: "Due Date To",
  //       fieldName: "dueDate",
  //       type: "date",
  //       operator: "lessThanOrEqual"
  //     }
  //   ];

  return (
    <>
      {" "}
      <Grid item container spacing={2}></Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGridForDashboard
            id="reconciliationListGrid"
            title="Reconciliation"
            columns={columns}
            multiSelect={true}
            filterFields={filterRows}
            // clientFilter={true}
            onSelectionChange={handleSelectionChange}
            searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
            source={source}
            transFormData={transFormData}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
            pageSize={10}
            // highlight={false}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            marginTop: "3rem",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <WSButton
            id="submit"
            label="Save"
            type="button"
            className={`ws-default ${
              selectedIds?.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds?.length === 0}
            loading={loading}
            size="medium"
            onClick={handleSaveClick}
          />
          <WSButton
            id="cancel"
            label="Cancel"
            type="button"
            onClick={handleCancelClick}
            size="medium"
            className="ws-cancel"
          />
        </Grid>
      </Grid>
    </>
  );
});
